import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            marginRight: {base: remCalc(-12), lg: remCalc(-40), xl: '0'},
            flexDirection: 'column',
            paddingY: {base: 'small-1.base', md: 'medium.md', lg: 'medium.lg', xl: 'medium.xl'},
            textAlign: 'center',
            gap: {base: 'small.base', md: 'small-1.md', lg: 'small-1.lg', xl: 'small-1.xl'},
        },
        headerGrid: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
            gap: 0,
        },
        title: {
            fontFamily: 'heading',
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
        },
        description: {
            fontFamily: 'heading',
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
        },
        cardsContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: {base: remCalc(6), md: remCalc(8)},
            justifyContent: 'flex-start',
            overflowX: {base: 'auto', md: 'visible'},
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': {display: 'none'},
        },
        card: {
            flexDirection: 'column',
            height: {base: remCalc(374), md: remCalc(470)},
            width: '100%',
            minWidth: {base: remCalc(280), md: 'auto'},
            maxWidth: {base: remCalc(280), md: remCalc(352)},
            flexShrink: {base: 0, md: 1},
            justifyContent: 'space-between',
            borderRadius: 'large-1',
            position: 'relative',
            overflow: 'hidden',
        },
        blur: {
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            pointerEvents: 'none',
            sx: {
                background:
                    'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.80) 100%)',
                backdropFilter: 'blur(2px)',
                WebkitBackdropFilter: 'blur(2px)',
                WebkitMaskImage: 'linear-gradient(transparent, black, black)',
                maskImage: 'linear-gradient(transparent, black, black)',
            },
        },
        cardIconAlignment: {
            alignItems: 'flex-start',
            padding: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        cardIconContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            padding: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            width: remCalc(32),
            height: remCalc(32),
        },
        icon: {
            width: remCalc(16),
            height: remCalc(16),
            fontSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        cardContent: {
            flexDirection: 'column',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
            position: 'relative',
            isolation: 'isolate',
            paddingX: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            paddingBottom: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            paddingTop: {
                base: 'medium-2.base',
                md: 'medium-2.md',
                lg: 'medium-2.lg',
                xl: 'medium-2.xl',
            },
            borderRadius: 'large-1',
            overflow: 'hidden',
        },
        cardTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            lineHeight: remCalc(18),
            color: 'foreground.neutral.inverse',
            position: 'relative',
            zIndex: 1,
            textAlign: 'left',
        },
        cardDescription: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            lineHeight: remCalc(18),
            color: 'foreground.neutral.dim',
            position: 'relative',
            zIndex: 1,
            textAlign: 'left',
        },
        cardButton: {
            width: '100%',
            mt: {base: remCalc(16), sm: remCalc(24), lg: remCalc(40)},
        },
        image: {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        },
    },
    variants: {
        slider: {
            cardsContainer: {
                overflow: {base: 'hidden', lg: 'unset'},
            },
        },
    },
    parts: [
        'container',
        'headerGrid',
        'title',
        'description',
        'cardsContainer',
        'card',
        'cardIconAlignment',
        'cardIconContainer',
        'icon',
        'cardContent',
        'cardTitle',
        'cardDescription',
        'cardButton',
        'image',
        'blur',
    ],
}
